export default "__VITE_ASSET__fY3ttw9M__"